import React from 'react';
import i18n from '@/i18n';
import '@/styles/ipe/workbench/components/HistoryPanelBodyLoading.css';

/**
 * 历史侧栏打开阶段共用加载态（与 AI 文案历史一致：转圈 + 文案）。
 * CSS：`.img2img-history__body-loading` + `.funding-table-loading-spinner`
 */
export default function HistoryPanelBodyLoading({ label = i18n.t('workbench:studioChrome.loading') }) {
  return (
    <div className="img2img-history__body-loading" role="status" aria-live="polite">
      <div className="funding-table-loading-spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
